import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guanji",
  "use": "icon-guanji-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-guanji\"><path d=\"M512 960A392 392 0 0 1 400 192.448v119.168A279.872 279.872 0 0 0 512 848a280 280 0 0 0 280-280A280 280 0 0 0 624 311.616V192.448A391.872 391.872 0 0 1 512 960zM456 120a56 56 0 0 1 112 0v448h-112v-448z\" p-id=\"4023\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol